/**
 * Convite que a pessoa abriu antes de ter sessão.
 *
 * Quem chega pelo link sem estar logado passa por login ou cadastro antes de
 * entrar no grupo. O código fica guardado aqui para que, autenticada, ela volte
 * direto para o convite — e o aceite aconteça sem precisar clicar no link de novo.
 *
 * sessionStorage sobrevive a um recarregamento no meio do cadastro, mas some ao
 * fechar a aba; se o navegador bloquear o acesso, cai na memória.
 */

const STORAGE_KEY = 'escalae:pending-invite';

let memoryFallback: string | null = null;

export function setPendingInvite(code: string): void {
  memoryFallback = code;
  try {
    sessionStorage.setItem(STORAGE_KEY, code);
  } catch {
    // Armazenamento indisponível (aba anônima, bloqueio): a memória basta.
  }
}

export function getPendingInvite(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY) ?? memoryFallback;
  } catch {
    return memoryFallback;
  }
}

export function clearPendingInvite(): void {
  memoryFallback = null;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nada a limpar além da memória.
  }
}

/** Para onde ir logo depois de autenticar: o convite pendente, se houver. */
export function postAuthPath(fallback: string): string {
  const code = getPendingInvite();
  return code ? `/convite/${encodeURIComponent(code)}` : fallback;
}
